import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const noDataAnimations = `
  @keyframes line-reveal {
    0% { width: 0; opacity: 0; }
    100% { width: 100%; opacity: 1; }
  }
`;

const NoDataFound = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "80vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#F8FAFC",
        borderRadius: 4,
        position: "relative",
        overflow: "hidden",
        border: `1px solid #E2E8F0`,
      }}
    >
      <style>{noDataAnimations}</style>

      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/98d2b3b5-ce57-48cf-8a48-4120baa2ccb6/iigIDQDY5b.lottie"
          loop
          autoplay
        />
      </Box>

      {/* TEXT */}
      <Box sx={{ textAlign: "center", zIndex: 1 }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 900,
            color: "#0F172A",
            letterSpacing: "2px",
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          No Data Found
        </Typography>

        <Box
          sx={{
            height: "2px",
            width: "40px",
            bgcolor: theme.palette.primary.main,
            margin: "0 auto 16px",
            animation: "line-reveal 1s ease-out forwards",
          }}
        />

        <Typography
          sx={{
            fontSize: "12px",
            color: "#64748B",
            fontWeight: 600,
            maxWidth: "240px",
            lineHeight: 1.6,
          }}
        >
          NO RECORDS MATCH THE SELECTED DATE RANGE OR FILTERS.
        </Typography>
      </Box>

      {/* DEBUG */}
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          right: 20,
          opacity: 0.4,
          fontFamily: "monospace",
          fontSize: "8px",
          color: "#475569",
          textAlign: "right",
          pointerEvents: "none",
        }}
      >
        STATUS: NULL_RESULT
        <br />
        QUERY_SCOPE: TEMPORAL
        <br />
        REF: 0x000
      </Box>
    </Box>
  );
};

export default NoDataFound;
